import React from "react";
import { Player } from "video-react";

import ReactJWPlayer from 'react-jw-player';

import '../../node_modules/video-react/dist/video-react.css'

import close from "../images/close.png";

export default function VideoModal(props) {
  return (
    <div className="VideoModal">
      <div className="VideoModal__Container">
        <div className="VideoModal__Container--Header">
          <img
            className="VideoModal__Container--Header__Img"
            src={close}
            alt=""
            onClick={props.closeModal}
          />
        </div>
        <div className="VideoModal__Container--Body">
        <ReactJWPlayer
          isAutoPlay={true}
          playerScript="https://cdn.jwplayer.com/libraries/2ocVgFwx.js"
          file={props.url}
          // playerId={"312360b7834287684c597e8aac7bf4d7_170_1601890163/playlist"}
          className={"iframeVideo"}
          image={props.thumbnail}
          // onThreeSeconds = {(evt) => this.onThreeSeconds(item.vidKey)}
          customProps={{
            style: { width: "700px", height: "550px"},
          }}
          onError={() => console.log('Video failed to load')}
          licenseKey="oIKbtCB/k9ZQ1/2h/NRjbgewxCB8jncv37Q/xVK2wY9A9eDE"
        />  

        {/* <video
          autoPlay
          style={{outline: 'none'}} 
          width="100%" 
          controls
          >
              <source src={props.url} type="video/mp4" />
              Your browser does not support the video tag.
        </video> */}
        </div>
      </div>
    </div>
  );
}
